// In theme.liquid or a custom JS file
document.addEventListener('DOMContentLoaded', function() {
  const colorInputs = document.querySelectorAll('[data-option-position="1"] input'); // adjust position
  
  colorInputs.forEach(input => {
    input.addEventListener('change', function() {
      const selectedColor = this.value.toLowerCase();
      const mediaItems = document.querySelectorAll('.product__media-item');
      
      mediaItems.forEach(item => {
        const alt = item.querySelector('img')?.alt?.toLowerCase() || '';
        if (alt.includes(selectedColor) || alt === '') {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });
    });
  });
});